"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductCaliber = void 0;
var getProductCaliber = function (product) {
    if (!product.caliberMin && !product.caliberMax)
        return undefined;
    return "Calibre : ".concat(product.caliberMin || '').concat(product.caliberMin && product.caliberMax ? '-' : '').concat(product.caliberMax || '', "mm");
};
exports.getProductCaliber = getProductCaliber;
exports.default = { getProductCaliber: exports.getProductCaliber };
//# sourceMappingURL=ProductCaliber.js.map